import { useRequiredContext } from "@lib/utils";

import { FloorSuggestions } from "../shared/FloorSuggestions/FloorSuggestions";
import { HaNContext } from "../shell/HaNContext";
import { FacilitiesOnFloor } from "./components/FacilitiesOnFloor";
import { FacilityCell } from "./FacilityCell";
import { useFacilitiesModel } from "./useFacilitiesModel";

export const FacilitiesList = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "facilities") return null;

  return <FacilitiesListContent />;
};

const FacilitiesListContent = () => {
  const { suggestions } = useFacilitiesModel();

  return (
    <>
      <FacilitiesOnFloor />

      <FloorSuggestions
        kind="facility"
        suggestions={suggestions}
        renderCell={facility => <FacilityCell facility={facility} />}
      />
    </>
  );
};
